export const blogPosts = [
  {
    id: "orms-fail-when-complexity-hit",
    title: "Unpopuler Opinion: ORMs Fail When Complexity Hits",
    excerpt: "If you ever doubt whether a specific problem should be solved using Raw SQL or an ORM, trust me - Raw SQL will be better option.",
    date: "2026-01-01",
    readTime: "4 min read",
    tags: ["Database Internals", "ORMs", "Performance"],
    markdownFile: "orms-fail-when-complexity-hit.md",
    published: true
  },
  {
    id: "ai-agents-might-take-your-job",
    title: "LLMs won't take your job, but AI agents might",
    excerpt: "I recently explored the research paper “LLM-Based Agents for Software Engineering” - and what it outlines is not just a technical evolution, it’s an existential shift.",
    date: "2025-12-01",
    readTime: "3 min read",
    tags: ["AI", "AI Agents", "SDLC", "Software Engineer"],
    markdownFile: "ai-agents-might-take-your-job.md",
    published: true
  },
  {
    id: "Why_Netflix_Bet_on_CockroachDB",
    title: "Why Netflix Bet on CockroachDB (Technical Breakdown)",
    excerpt: "Are you using right database for your application? Or just relying on maybe what you dont know perfectly.",
    date: "2025-12-15",
    readTime: "2 min read",
    tags: ["System Design", "Database", "Performance", "Backend"],
    markdownFile: "Why_Netflix_Bet_on_CockroachDB.md",
    published: true
  },
  {
    id: "Choosing_right_way_to_connect_server_and_client",
    title: "Choose the Right Way to Connect the Server & Frontend ",
    excerpt: "Have you ever been stuck deciding the best way to connect your server with the frontend? Should you go for APIs, WebSockets, or something else?",
    date: "2025-02-01",
    readTime: "10 min read",
    tags: ["System Design", "Communication", "Performance", "Backend", "Server", "Frontend"],
    markdownFile: "Choose_Right_Way_Server_Frontend.md",
    published: true
  }
];
